import { Breadcrumb, Button, Form, Input, Steps } from "antd";
import "../ep.scss";
import "./epValid.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import ReactInputMask from "react-input-mask";
import FormItemLabel from "antd/es/form/FormItemLabel";
import { regexFormater, validateInput } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import Loading from "../../../auxiliary/loader/loading";
import Packages from "./packages";
import { switchPlanID } from "../../../../tools/services";
import { useLocation } from "react-router-dom";
import Profile from "../../../corporate_subscriber_search/corporate/profile/profile";
const EPValid = () => {
	const [t] = useTranslation("global");
	const { queryPackage } = useDealer();
	const location = useLocation();

	const [pack, setPack] = useState({
		isPackages: false,
		isLoading: false,
		cagegoryList: [],
		packageList: [],
		msisdn: "",
		purchase: location?.state || null,
	});

	useEffect(() => {
		const initalPackages = async () => {
			if (pack?.purchase?.inT_MSISDN) {
				prossesPackages();
			}
		};
		initalPackages();
	}, []);

	const handleSubmit = async (values) => {
		prossesPackages(values);
	};

	const prossesPackages = async (values = null) => {
		setPack((pc) => ({ ...pc, isLoading: true }));

		let payload = {
			msisdn: pack?.purchase?.inT_MSISDN || regexFormater(values?.msisdn).removeSpace(),
			planid: switchPlanID().extraPackage,
		};

		let response = await queryPackage(payload);

		if (response) {
			let groups = [];
			let subgroups = [];

			response.forEach((index) => {
				// Add group
				let groupIndex = groups.findIndex((item) => item.productGroupId === index.productGroupId);
				if (groupIndex === -1) {
					groups.push({
						productGroupId: index.productGroupId,
						productGroupName: index.productGroupName,
						productGroupOrderId: index.productGroupOrderId,
					});
				}

				// Add subgroup
				let subgroupIndex = subgroups.findIndex((item) => item.productSubGroupId === index.productSubGroupId);
				if (subgroupIndex === -1) {
					subgroups.push({
						productGroupId: index.productGroupId,
						productSubGroupId: index.productSubGroupId,
						productSubGroupName: index.productSubGroupName,
						productSubOrderId: index.productSubOrderId,
					});
				}
			});

			// Sort groups
			groups.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);

			// Sort subgroups
			subgroups.sort((a, b) => a.productSubOrderId - b.productSubOrderId);

			// Remove duplicate groups
			let uniqueGroupIds = new Set();
			let uniqueGroups = groups.filter((item) => {
				if (!uniqueGroupIds.has(item.productGroupId)) {
					uniqueGroupIds.add(item.productGroupId);
					return true;
				}
				return false;
			});

			// Remove duplicate subgroups
			let uniqueSubgroupIds = new Set();
			let uniqueSubgroups = subgroups.filter((item) => {
				if (!uniqueSubgroupIds.has(item.productSubGroupId)) {
					uniqueSubgroupIds.add(item.productSubGroupId);
					return true;
				}
				return false;
			});

			// Build categories
			let categories = uniqueGroups.map((group) => {
				let subgroup = uniqueSubgroups
					.filter((subgroup) => subgroup.productGroupId === group.productGroupId)
					.map((subgroup) => ({
						inT_ProductSubGroupId: subgroup.productSubGroupId,
						stR_ProductSubGroupName: subgroup.productSubGroupName,
					}));

				return {
					productGroupId: group.productGroupId,
					productGroupName: group.productGroupName,
					subgroup: subgroup,
				};
			});

			//Remove duplicate Package
			let uniquePackagesIds = new Set();
			let uniquePackages = response.filter((item) => {
				if (!uniquePackagesIds.has(item.packageId)) {
					uniquePackagesIds.add(item.packageId);
					return true;
				}
				return false;
			});

			setPack((pc) => ({ ...pc, isPackages: true, msisdn: payload.msisdn, packageList: uniquePackages, cagegoryList: categories }));
		} else {
			setPack((pc) => ({ ...pc, isPackages: false }));
		}
		setPack((pc) => ({ ...pc, isLoading: false }));
	};
	return (
		<>
			<div className="container-main container-ep">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("extraPackage.title") }]}
					/>
					<div className="title-page">
						<h3>{t("extraPackage.title")}</h3>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main ep-container">
						<div className="g-format-page">
							{pack?.purchase && (
								<>
									<Profile Profile={pack?.purchase} state />
									<br />
								</>
							)}
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											items={[
												{
													title: "انتخاب بسته",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "رسید",
												},
											]}
										/>
									</div>
								</div>
								<div className="valid-container">
									<div className="holder-validExtraPackage">
										<div className="title-page">{!pack?.purchase && <h3>لطفا شماره موبایل خود را وارد کنید</h3>}</div>
										<div className="holder-form">
											{!pack?.purchase && (
												<Form layout="inline" onFinish={handleSubmit}>
													<Form.Item className="input-normal" name="msisdn" rules={[validateInput({ t: t, validate: true, type: "msisdnOrg" })]}>
														<div>
															<FormItemLabel label="شماره موبایل" />
															<ReactInputMask dir="ltr" mask="0\9\9\91 99 99 99" className="msisdn-mask" inputMode="numeric" autoComplete="off" />
														</div>
													</Form.Item>
													<Form.Item>
														<FormItemLabel label="&nbsp;" />
														<Button className="btn-normal btn-green" type="default" htmlType="submit">
															نمایش بسته‌ها
														</Button>
													</Form.Item>
												</Form>
											)}
										</div>
										{pack?.isPackages && (
											<div className="holder-show-packages">
												<Packages
													categoryList={pack?.cagegoryList}
													packagesList={pack?.packageList}
													msisdn={pack?.msisdn}
													purchase={pack.purchase || null}
												/>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			<Loading isOpen={pack?.isLoading} />
		</>
	);
};

export default EPValid;
